import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, PropertyTenancies } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';
import { FormValues } from './components/schemas';

async function getTenancies(propertyId: number) {
    const response = await getBFFApiClient().get<APIResponse<PropertyTenancies>>(`/v1/property/${propertyId}/tenancies`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get property tenancies');
    }

    return response.data.data;
}

async function editTenancy(
    propertyId: number,
    tenancyId: number,
    data: FormValues
) {
    const response = await getBFFApiClient().put<APIResponse<null>>(`/v1/property/${propertyId}/tenancy/${tenancyId}`, data);

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to edit tenancy');
    }

    return response.data.data;
}

async function addTenancy(
    propertyId: number,
    data: FormValues
) {
    const response = await getBFFApiClient().post<APIResponse<null>>(`/v1/property/${propertyId}/tenancy`, data);

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to add tenancy');
    }

    return response.data.data;
}

async function archiveTenancy(
    propertyId: number,
    tenancyId: number
) {
    const response = await getBFFApiClient().put<APIResponse<null>>(`/v1/property/${propertyId}/tenancy/${tenancyId}/archive`);

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to archive tenancy');
    }

    return response.data.data;
}

export {
    getTenancies,
    editTenancy,
    addTenancy,
    archiveTenancy,
};
